import { MoveToPosCmd } from './movetopos';

// Click event range constants
const NPC_CLICK_EVENT_RANGE = 2.5;
const AVT_CLICK_EVENT_RANGE = 10.0;
const ITEM_CLICK_EVENT_RANGE = 1.5;

const _targetDelta = new THREE.Vector3();
const _normDir = new THREE.Vector3();

export class MoveToObjCmd extends MoveToPosCmd {
  target: any;
  distance: number | undefined;

  constructor(object: any, targetObjRef: any, distance?: number) {
    let targetPos = new THREE.Vector2(targetObjRef.position.x, targetObjRef.position.y);
    super(object, targetPos);
    this.target = targetObjRef;
    this.distance = distance;
  }

  update(delta: number) {
    if (this.wantInterrupt) {
      this.isComplete = true;
      return delta;
    }

    // We check this here as our underlying object reference can
    //   change to a real object when it was once a proxy, so we
    //   mind as well be as clever as we can.
    if (this.distance === undefined) {
      const gameObject = this.target.object;
      if (gameObject) {
        // Use duck typing to avoid circular dependency issues
        if (gameObject.type === 'npc') {
          this.distance = NPC_CLICK_EVENT_RANGE;
        } else if (gameObject.type === 'char') {
          this.distance = AVT_CLICK_EVENT_RANGE;
        } else if (gameObject.type === 'item') {
          this.distance = ITEM_CLICK_EVENT_RANGE;
        } else {
          console.warn('Distanceless MovToObj on unknown GO type.')
          this.distance = 0;
        }
      }
    }

    const thisObj = this.object;
    const thisPos = thisObj.position;
    const targetPos = this.target.position;

    let wantDist = (this.distance !== undefined) ? this.distance : 0;
    _targetDelta.copy(targetPos).sub(thisPos);

    this.object.direction = Math.atan2(_targetDelta.y, _targetDelta.x) + Math.PI / 2;

    if (_targetDelta.lengthSq() <= wantDist*wantDist) {
      this.isComplete = true;
      this.emit('finish');
      return delta;
    }

    this.targetPos.copy(targetPos);
    if (wantDist > 0) {
      _normDir.copy(_targetDelta).normalize().multiplyScalar(wantDist);
      this.targetPos.add(_normDir);
    }

    return super.update(delta);
  }
}

